import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, watch } from "vue"
import NewProjectWizard from "@/modules/Missions/CreateNewProject/NewProjectWizard.vue"
import { useUtilities } from "@/hooks/useUtilities"
import { useTranslation } from "@/i18n/useTranslation"


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateNewProject',
  props: {
    value: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }) {

const props = __props as {
  value: boolean
}

const { t } = useTranslation("Missions/CreateNewProject")





const searchParams = new URLSearchParams(window.location.search)
const showNewProjectWizard = ref(false)

const onOpenDialog = () => {
  showNewProjectWizard.value = true
  const { updateSearchParams } = useUtilities()
  updateSearchParams({ key: "dialog", value: "open" })
}

const onCloseDialog = () => {
  const { deleteSearchParams } = useUtilities()

  showNewProjectWizard.value = false
  emit("close")
  deleteSearchParams("dialog")
}

watch(
  () => props.value,
  (value) => {
    if (value) {
      onOpenDialog()
    }
  }
)
onMounted(() => {
  const dialog = searchParams.get("dialog")

  if (dialog === "open") {
    onOpenDialog()
  }
})

return { __sfc: true,t, emit, props, searchParams, showNewProjectWizard, onOpenDialog, onCloseDialog, NewProjectWizard }
}

})